export default class InfoExpander {
	constructor() {
		document.addEventListener('click', (e) => {
			const card = e.target.closest('.card-info-expander');
			if (!card) {
				return;
			}
			const toggleBtn = card.querySelector('.btn-info-toggle');
			if (toggleBtn) {
				const toggle = e.target.closest('.btn-info-toggle,.card-img,.card-title');
				if (toggle) {
					const card = toggle.closest('.card');
					if (card) {
						card.classList.toggle('expanded');
						toggle.setAttribute(
							'aria-label',
							card.classList.contains('expanded') ? 'Show less information' : 'Show more information'
						);
					}
				}
			}
		});
	}
}
